// ───────────────────────────────────────────────
// Lazy TargetFace — same API as components/Target.jsx's TargetFace, but the
// full Target module (~1500 lines: every face renderer + the interactive
// drag/tap machinery) is loaded on demand instead of riding the entry bundle.
//
// Use this from components that are part of the eagerly-loaded entry graph
// (Home / Practice thumbnails). Lazy-loaded routes (Score, Stats, RoundDetail…)
// should keep importing TargetFace from ./Target directly — they're already
// code-split, and their interactive use wants the real module synchronously.
//
// The Suspense fallback reserves the exact size×size square the face SVG will
// occupy, so nothing shifts when the chunk lands. (#1669)
// ───────────────────────────────────────────────
import { lazy, Suspense } from "react";

const Face = lazy(() =>
  import("./Target").then((m) => ({ default: m.TargetFace }))
);

export function TargetFaceLazy({ size = 440, ...rest }) {
  return (
    <Suspense
      fallback={<div style={{ width: size, height: size }} aria-hidden="true" />}
    >
      <Face size={size} {...rest} />
    </Suspense>
  );
}
